const __WEBPACK_NAMESPACE_OBJECT__ = require("video.js/dist/video-js.css");